// 📁 src/pages/ConfirmedTransfersPage.jsx
import { useEffect, useState } from "react";
import { Table } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "../styles/TableStyles.css";
import { XCircle } from "lucide-react";

export default function ConfirmedTransfersPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  const getUser = async () => {
    try {
      const res = await fetch("/api/protected/me", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      const json = await res.json();
      return {
        pharmacyCode: json?.user?.pharmacyCode?.replace(/^0+/, ""),
        firma: json?.user?.firma,
      };
    } catch (e) {
      console.error("Chyba při načítání uživatele:", e);
      return null;
    }
  };

  const fetchData = async (firma, pharmacyCode) => {
    try {
      const res = await fetch(`/api/transfers/confirmed/${firma}/${pharmacyCode}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      const json = await res.json();
      setData(json);
    } catch (e) {
      console.error("Chyba načítání confirmed transfers:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      const u = await getUser();
      setUser(u);
      if (u) fetchData(u.firma, u.pharmacyCode);
    })();
  }, []);

  const cancelConfirmation = async (id) => {
    if (!user) return;
    try {
      await fetch(`/api/transfers/cancelConfirmation/${user.firma}/${user.pharmacyCode}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ id }),
      });
      fetchData(user.firma, user.pharmacyCode);
    } catch (e) {
      console.error("Chyba při rušení potvrzení:", e);
    }
  };

  if (loading) return <p>Načítám…</p>;

  return (
    <div className="page">
      <h1>Převodky – Potvrzené</h1>
      <Table className="styled-table">
        <thead>
          <tr>
            <th>PDK</th>
            <th style={{ width: "25%" }}>Název</th>
            <th>Expirace</th>
            <th>Šarže</th>
            <th>Množství</th>
            <th>Zdrojová pobočka</th>
            <th>Akce</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row._id}>
              <td>{row.PDK}</td>
              <td>{row.Název}</td>
              <td>{new Date(row.Exspirace).toLocaleDateString()}</td>
              <td>{row.Šarže}</td>
              <td>{row.Množství}</td>
              <td>{row.pharmacyCode}</td>
              <td>
                {row.stav === "potvrzeno" && (
                  <button
                    onClick={() => cancelConfirmation(row._id)}
                    style={{
                      padding: "2px 6px",
                      fontSize: "12px",
                      background: "#dc3545",
                      border: "none",
                      color: "white",
                      borderRadius: "4px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <XCircle size={14} style={{ marginRight: "4px" }} />
                    Zrušit potvrzení
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
